import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {Button} from 'reactstrap';
import {images} from '../images/images';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';

const RequestSent = (props) => {
  const {backToPrivateArea, startOver} = props;
  useEffect(() => {
    switch (props.errorReason) {
      case 'bundle':
        gaEvent(
          gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST_SENT.category,
          gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST_SENT.eventType,
          gaParams.CHANGE_PRICE_PLAN_BUNDLE_CALLBACK_REQUEST_SENT.eventParams
        );
        break;
      case 'sub_status':
        gaEvent(
          gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST_SENT.category,
          gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST_SENT.eventType,
          gaParams.CHANGE_PRICE_PLAN_SUB_STATUS_CALLBACK_REQUEST_SENT.eventParams
        );
        break;
      case 'fix_price_with_futurePP':
        gaEvent(
          gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST_SENT.category,
          gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST_SENT.eventType,
          gaParams.CHANGE_PRICE_PLAN_NOT_AVAILABLE_FOR_LIMITED_CALLBACK_REQUEST_SENT.eventParams
        );
        break;
      case 'error_on_change':
        if (props.limited) {
          gaEvent(
            gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_SENT_FOR_LIMITED.category,
            gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_SENT_FOR_LIMITED.eventType,
            gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_SENT_FOR_LIMITED.eventParams
          );
        } else {
          gaEvent(
            gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_SENT.category,
            gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_SENT.eventType,
            gaParams.CHANGE_PRICE_PLAN_ERROR_ON_CHANGE_CALLBACK_REQUEST_SENT.eventParams
          );
        }

        break;
      default:
      // code block
    }
  }, []);

  return (
    <div className='request-sent-wrapper justify-content-center m-auto'>
      <div className='request-sent-container'>
        <div className='text-center image'>
          <Image src={images.sent} alt='image-sent' />
        </div>

        <div className='bold main-text d-block'>
          <p>הבקשה נשלחה והיא בדרך אלינו</p>
        </div>

        <div className='description-text d-block text-center'>
          <p>נחזור אליכם תוך יום עסקים אחד</p>
        </div>

        <div className='m-auto text-center'>
          <BtnSubmit text='אוקיי' onclick={startOver} />
        </div>

        {props.isLogin && (
          <div className='m-auto text-center'>
            <Button color='link' className='pink-text btn' onClick={backToPrivateArea}>
              חזרה לאזור האישי
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestSent;
